// import React, { useContext, useEffect, useRef, useState } from "react";
// import Video from "../Video/Video";
// import { Dialog , Box, Typography, Button} from "@mui/material"; // Import Dialog component from Material-UI
// import VideoContext from "../../../contexts/VideoContext";
// import './VideoChat.css';
// import { toast } from "react-toastify";

// const VideoChat = () => {

//         const { 
//         openVideoChat, 
//         setOpenVideoChat, 
//         callAccepted, 
//         setStream,
//         stream,
//         myVideo,
//         userVideo,
//         callRejected, 
//         setCallRejected,
//         leaveCall1,
//         otherUser,
//         call,
//         callEnded,
//         } = useContext(VideoContext);

//     const [fullWidth, setFullWidth] = useState(true);
//     const [maxWidth, setMaxWidth] = useState('md');

//     useEffect(()=>{
//         if(callAccepted){
//             setMaxWidth('md')
//         }
//         else{
//             setMaxWidth('xs');
//         }
//     }, [callAccepted]);
  

//     const cancelCall = () => {
//         leaveCall1();
//         setCallRejected(false);
//         setOpenVideoChat(false);
//         stream.getTracks().forEach((track) => {
//             track.stop();
//         });
//     }

//     useEffect(()=>{
//         if (callRejected){
//             toast.error('User Cannot Join the Call at the Moment');
//         }
//     }, [callRejected]);

//     // useEffect(() => {
//     //     navigator.mediaDevices.getUserMedia({
//     //         video: true, audio: true
//     //     }).then((currentStream) => {
//     //         setStream(currentStream);
//     //         if (myVideo.current) {
//     //             if ('srcObject' in myVideo.current) {
//     //                 myVideo.current.srcObject = currentStream;
//     //             } else {
//     //                 // Fallback for older browsers
//     //                 myVideo.current.src = URL.createObjectURL(currentStream);
//     //             }
//     //             // myVideo.current.play();
//     //         } else {
//     //             console.error("Video element not found.");
//     //         }
//     //     }).catch((error) => {
//     //         console.log("Error accessing media devices:", error);
//     //     });
//     // }, [callAccepted]);


//     return (
//         <Dialog 
//         fullWidth={fullWidth}
//         maxWidth={maxWidth}
//         open={openVideoChat} 
//         >
//             {callAccepted ? (
//             <Box sx={{height: "100%", width: "100%" }} p={1}>
//             <Video  />
//             </Box>
//             )
//             : (
//             <Box sx={{ display: 'flex',flexDirection:'column',alignItems: 'center', justifyContent: 'center', height: "100%", width: "100%" }} p={2}>
//             <div id="SqCo">
//             <p>
//             {callRejected ? 'User Cannot Join the Call at the Moment'
//              :
//              'Waiting for the call to be accepted'
//              }
//             <span className="point one"> .</span>
//             <span className="point two">...</span>
//             <span className="point three">. </span>
//             </p>
//             </div>
//             <Box display='flex' justifyContent='center' py={2}> 
//                <Button variant="contained" color='error' onClick={cancelCall}>Cancel</Button>
//             </Box>
//             </Box>
//             )}

//         </Dialog>
//     );
// };

// export default VideoChat;


// VideoChat.js - Enhanced UI
import React, { useContext, useEffect, useState } from "react";
import { 
  Dialog, 
  Box, 
  Typography, 
  Button,
  Paper,
  Avatar,
  CircularProgress,
  Fade
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { 
  PhoneDisabled as PhoneDisabledIcon,
  VideocamOff as VideocamOffIcon 
} from "@material-ui/icons";
import VideoContext from "../../../contexts/VideoContext";
import Video from "../Video/Video";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: theme.spacing(3),
    overflow: 'hidden',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
  },
  videoContainer: {
    height: "100%", 
    width: "100%", 
    padding: theme.spacing(2)
  },
  videoInner: {
    height: '100%', 
    borderRadius: theme.spacing(2),
    background: '#000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  waitingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center', 
    justifyContent: 'center', 
    minHeight: 300,
    padding: theme.spacing(4),
    textAlign: 'center'
  },
  loaderContainer: {
    position: 'relative',
    marginBottom: theme.spacing(3)
  },
  loader: {
    color: 'white',
    opacity: 0.3
  },
  avatarIcon: {
    width: 64,
    height: 64,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'rgba(255,255,255,0.2)',
    backdropFilter: 'blur(10px)'
  },
  title: {
    color: 'white',
    fontWeight: 600,
    marginBottom: theme.spacing(1)
  },
  subtitle: {
    color: 'rgba(255,255,255,0.8)',
    marginBottom: theme.spacing(3),
    maxWidth: 280
  },
  cancelButton: {
    borderRadius: theme.spacing(2),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    textTransform: 'none',
    fontSize: '1rem',
    fontWeight: 600,
    boxShadow: '0 4px 14px 0 rgba(0,0,0,0.25)',
    '&:hover': {
      boxShadow: '0 6px 20px 0 rgba(0,0,0,0.35)'
    }
  }
}));

const VideoChat = () => {
  const classes = useStyles();
  const { 
    openVideoChat, 
    setOpenVideoChat, 
    callAccepted, 
    setStream,
    stream,
    callRejected, 
    setCallRejected,
    leaveCall1
  } = useContext(VideoContext);

  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState('md');

  useEffect(() => {
    if (callAccepted) {
      setMaxWidth('md');
    } else {
      setMaxWidth('xs');
    }
  }, [callAccepted]);

  const cancelCall = () => {
    leaveCall1();
    setCallRejected(false);
    setOpenVideoChat(false);
    stream?.getTracks().forEach((track) => {
      track.stop();
    });
  };

  useEffect(() => {
    if (callRejected) {
      toast.error('User Cannot Join the Call at the Moment');
    }
  }, [callRejected]);

  return (
    <Dialog 
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      open={openVideoChat}
      PaperProps={{
        className: classes.dialogPaper
      }}
    >
      {callAccepted ? (
        <Box className={classes.videoContainer}>
          <Video />
        </Box>
      ) : (
        <Fade in={!callAccepted}>
          <Box className={classes.waitingContainer}>
            <Box className={classes.loaderContainer}>
              <CircularProgress 
                size={80} 
                thickness={2}
                className={classes.loader}
              />
              <Avatar className={classes.avatarIcon}>
                <VideocamOffIcon style={{ fontSize: 32, color: 'white' }} />
              </Avatar>
            </Box>

            <Typography variant="h6" className={classes.title}>
              {callRejected ? 'Call Unavailable' : 'Connecting...'}
            </Typography>
            
            <Typography variant="body2" className={classes.subtitle}>
              {callRejected 
                ? 'User cannot join the call at the moment' 
                : 'Waiting for the call to be accepted'}
            </Typography>

            <Button 
              variant="contained" 
              color="secondary"
              startIcon={<PhoneDisabledIcon />}
              onClick={cancelCall}
              className={classes.cancelButton}
            >
              Cancel Call
            </Button>
          </Box>
        </Fade>
      )}
    </Dialog>
  );
};

export default VideoChat;
